export const padId = (value: string | number, shift: number) => `#${String(value).padStart(shift, '0')}`;
